import {colors} from '../defaultSettings';
import {btn_icon_sm, font_s_sm, font_s_xs, svg_sm, absCenter, clearfix} from '@xpertdox_js/xdstyle';

export default {
  container: {
    width: '100%',
    position: 'fixed',
    zIndex: 3,
    left: 'auto',
    top: 'auto',
    bottom: 0,
    // borderRight: '1px solid ' + colors.headerMenuBorderDrk,
    marginTop: '20px',
  },
  scrollbarContainer: {
    background: colors.bg.panel,
    position: 'absolute',
    top: 0, left: 0,
    transform: 'translateY(-100%)',
    height: '14px',
    opacity: .5,
    marginLeft: '15px'
  },
  scrollbar: {
    width: '20%',
    height: '100%',
    background: colors.bg.title,
    position: 'absolute',
    left: 0,
    // transform: 'translateX(-100%)'
  },
  toolbarContent: {
    ...clearfix,
    background: colors.bg.header,
    borderTop: '1px solid ' + colors.headerMenuBorderDrk,
    padding: '5px',
  },
  pageifyContainer: {
    float: 'right',
    maxWidth: '33.333%',
    ...font_s_sm,
  },
  pageCountContainer: {
    ...absCenter,
    textAlign: 'center',
    ...font_s_xs,
    color: colors.textGray,
  },
  pagifyBtn: {
    ...btn_icon_sm,
    background: 'none',
    padding: '10px',
    borderRadius: '5px',
    fill: colors.toolbarItemText,
  },
  pagifyBtnHov: {
    background: colors.bg.toolbarItemHov,
    boxShadow: '0 1px 3px ' + colors.opacShade,
    fill: colors.toolbarItemTextHov,
  },
  pagifyBtnAct: {
    background: colors.bg.toolbarItemAct,
    fill: colors.highlight,
    boxShadow: 'inset 0 1px 3px ' + colors.opacShade,
  },
  svg: {
    ...svg_sm,
    ...absCenter,
  },
  input: {
    background:  colors.bg.panelInput,
    color: colors.textGray,
    width: '45px',
    height: '32px',
    textAlign: 'center',
    marginLeft: '5px',
    borderRadius: '5px',
    border: '1px solid ' + colors.opacShadeLt,
    boxShadow: 'inset 0px 1px 2px rgba(0,0,0,0.1)',
  },
  inputForm: {
    display: 'inline-block',
  },
  count: {
    display: 'inline-block',
    padding: '0 5px',
    color: colors.textGray,
    ...font_s_sm,
    marginTop: '10px'
  },
  inputWrap: {
    display: 'inline-block',
    verticalAlign: 'top',
  },
  pageLimitContainer: {
    float: 'left',
    width: '33.333%'
  },

  pageLimit: {
    container: {
      float: 'left',
      maxWidth: '122px',
      boxShadow: 'none',
      height: '32px',
      border: 'none',
      ...font_s_sm,
    },
    display: {
      width: '45px',
      minWidth: 'none',
      height: '32px',
      padding: 0,
      background: colors.bg.panelInput,
      boxShadow: 'inset 0px 1px 2px rgba(0,0,0,0.1)',
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      border: '1px solid ' + colors.opacShadeLt,
      borderLeft: colors.bg.toolbarItem === 'none' ? '1px solid ' + colors.opacShadeLt : 'none',
    },
    displayText: {
      ...absCenter,
      color: colors.textGray,
      ...font_s_sm,
    },
    button: {
      ...font_s_sm,
      background: colors.bg.toolbarItem,
      color: colors.toolbarItemText,
      minWidth: '75px',
      height: '32px',
      padding: 0,
      border: colors.bg.toolbarItem !== 'none' ? '1px solid ' + colors.opacShadeLt : 'none',
      borderColor: colors.bg.toolbarItem !== 'none' ? colors.opacShadeLt : 'rgba(255,255,255,0.12)',
    },
    buttonHov: {
      background: colors.bg.toolbarItemHov,
      boxShadow: '0 1px 3px ' + colors.opacShade,
      color: colors.toolbarItemTextHov,
    },
    buttonActive: {
      background: colors.bg.toolbarItemAct,
      borderColor: colors.bg.toolbarItem !== 'none' ? colors.opacShadeLt : 'rgba(255,255,255,0.12)',
      color: colors.highlight,
      border: '1px solid ' + colors.opacShadeLt,
      boxShadow: 'inset 0px 1px 4px rgba(0,0,0,0.09)',
    },
    selectMenu: {
      top: 'auto',
      bottom: '100%',
      marginBottom: '8px',
      animation: 'slide-in-from-top-w-fade .32s ease-out',
      border: '1px solid ' + colors.opacShadeLt,
      background: colors.bg.headerMenu
    },
    menuItem: {
      background: 'none',
      color: colors.headerText,
      borderBottom: '1px solid ',
      borderColor: colors.opacShade,
    },
    menuItemHov: {
      background: colors.highlight,
      color: colors.textLight,
      borderColor: colors.bg.highlight,
    }
  },
}
